import { render } from "./BsTemplateTerminalView.vue?vue&type=template&id=705e362c"
import script from "./BsTemplateTerminalView.vue?vue&type=script&lang=js"
export * from "./BsTemplateTerminalView.vue?vue&type=script&lang=js"

import "./BsTemplateTerminalView.vue?vue&type=style&index=0&id=705e362c&lang=css"
import "./BsTemplateTerminalView.vue?vue&type=style&index=1&id=705e362c&lang=css"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/manage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__